var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCommentEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_comment-empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "in-tool-/-icon_comment-empty",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_comment-empty"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-5",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4182534,22.0032251 C21.3551939,22.0032911 21.2925409,21.9931311 21.2327338,21.9731409 L15.8125527,20.1664138 C13.0233391,21.46473 9.76446725,21.2501346 7.16958724,19.5972779 C4.57470724,17.9444213 3.00254424,15.0818 3,12.0052223 L3,11.5038179 C3,11.4937898 3,11.4820904 3,11.4720623 C3.25087176,6.89846058 6.90494951,3.24726403 11.4787477,3 L12.0252784,3 C16.9885986,3.01748096 21.0042031,7.04354479 21.0087732,12.0068936 C21.0107286,13.3228012 20.7219466,14.6228908 20.1630712,15.814224 L21.9697982,21.2344051 C22.0294702,21.412847 21.9996668,21.6090992 21.8897096,21.7617808 C21.7797524,21.9144623 21.6030655,22.0049329 21.4149107,22.0048965 L21.4182534,22.0032251 Z M15.770769,18.951344 C15.8338261,18.9513074 15.8964744,18.9614666 15.9562886,18.9814282 L20.493998,20.4856413 L18.989785,15.9479319 C18.9404106,15.7996208 18.952448,15.6377181 19.0232119,15.4983393 C20.9497613,11.6302331 19.3761942,6.93272753 15.5083674,5.00561743 C14.4284362,4.45913034 13.2356051,4.17294245 12.0252784,4.1699435 L11.5238741,4.1699435 C7.559264,4.39476148 4.39476148,7.559264 4.1699435,11.5238741 L4.1699435,12.0035509 C4.1745494,16.3298697 7.68057484,19.8358951 12.0068936,19.840501 L12.0252784,19.840501 C13.2350474,19.8373033 14.4272905,19.5511191 15.506696,19.0048271 C15.5893596,18.9666943 15.6797822,18.9483809 15.770769,18.951344 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentEmpty);
export default __webpack_public_path__ + "static/media/icon_comment-empty.184d3ec54477287bc5b6ef1d60a5e9a2.svg";
export { ForwardRef as ReactComponent };